import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DownloadsService } from 'src/app/shared/services/downloads.service';

@Component({
  selector: 'app-upload-apk-modal',
  templateUrl: './upload-apk-modal.component.html',
  styleUrls: ['./upload-apk-modal.component.scss'],
})
export class UploadApkModalComponent implements OnInit {
  selectedFile: File | null = null;
  isSubmitting: boolean = false;

  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(
    public activeModal: NgbActiveModal,
    private spinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private downloadsService: DownloadsService
  ) {}

  ngOnInit(): void {}

  onFileSelected(event: any): void {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    // Check if file is APK
    const isApk = file.name.toLowerCase().endsWith('.apk');
    const isApkMimeType =
      file.type === 'application/vnd.android.package-archive' ||
      file.type === 'application/octet-stream';

    if (!isApk && !isApkMimeType) {
      this.toastr.error('Please select an APK file');
      this.selectedFile = null;
      return;
    }

    this.selectedFile = file;
  }

  removeFile(): void {
    this.selectedFile = null;
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  browseFiles(): void {
    this.fileInput.nativeElement.click();
  }

  async submit(): Promise<void> {
    if (!this.selectedFile) {
      this.toastr.error('Please select an APK file');
      return;
    }

    this.isSubmitting = true;
    this.spinnerService.show();
    try {
      const res = await this.downloadsService.uploadApkFile(this.selectedFile);
      this.spinnerService.hide();
      this.isSubmitting = false;

      if (res && res.code === 200) {
        this.toastr.success('APK file uploaded successfully!');
        this.activeModal.close(res);
      } else {
        this.toastr.error(res?.message || 'Failed to upload APK file');
      }
    } catch (err: any) {
      this.spinnerService.hide();
      this.isSubmitting = false;
      console.error(err);
      this.toastr.error(err?.error?.message || err?.message || 'Failed to upload APK file');
    }
  }
}


